<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <div :id="componentId" class="augmented-range-block">
    <h1 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="range-title">
      {{ rangeProductData.range_title }}
    </h1>
    <h2 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="range-subtitle">
      {{ rangeProductData.range_subtitle }}
    </h2>
    <augment-product-carousel
      v-if="rangeProductData.range_products.length > 0"
      :carousel-identifier="carouselIdentifier"
      :enable-navigation="true"
      :module-title="rangeProductData.range_title"
      @updateProduct="updateProduct"
    >
      <div
        v-for="(product, index) in rangeProductData.range_products"
        :key="index"
        :slot="`product${index + 1}`"
        class="routine-product"
        :data-tagging-on-impression="JSON.stringify(product.tagging_impression)"
      >
        <img
          v-if="product.productFirstImage"
          :src="product.productFirstImage.Src"
          :alt="product.productFirstImage.Alt"
          class="range-block-image-slides"
        />
        <h2 class="range-product-name">{{ product.title }}</h2>
        <a
          class="learn-more-button"
          @click="rangeLearnTagging(product.tagging_click, product.url)"
          >{{ rangeProductData.range_underlined_text }}</a
        >
      </div>
    </augment-product-carousel>
    <span
      v-if="rangeProductData.range_cta_text"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="cta-option-text"
      >{{ rangeProductData.cta_option }}</span
    >
    <a
      v-if="rangeProductData.range_cta_text"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      :href="rangeProductData.cta_link"
      class="discover-cta-button ripple-animation ripple-animation--black"
      @click="discoverClicked(rangeProductData.range_products)"
      >{{ rangeProductData.range_cta_text }}</a
    >
  </div>
</template>

<script>
export default {
  name: 'range-block',
  props: {
    rangeProductData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      carouselIdentifier: `carousel-${Date.now()}`,
      componentId: 'range',
      productNo: 0,
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    updateProduct(value) {
      this.productNo = value;
    },
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
    discoverClicked(products) {
      let name, id;
      products.forEach((item, index) => {
        if (index == this.productNo) {
          if (
            item.tagging_impression &&
            item.tagging_impression.ecommerce &&
            item.tagging_impression.ecommerce.impressions &&
            item.tagging_impression.ecommerce.impressions.length
          ) {
            name = item.tagging_impression.ecommerce.impressions[0]['name'];
            id = item.tagging_impression.ecommerce.impressions[0]['id'];
          }
        }
      });
        dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'augmented products',
        eventAction: `select::the range::${name}::${id}`,
        eventLabel: this.rangeProductData.range_cta_text.toLowerCase(),
      });
    },
    rangeLearnTagging(value, url) {
      if (
        value.ecommerce &&
        value.ecommerce.click &&
        value.ecommerce.click.impressions &&
        value.ecommerce.click.impressions.length
      ) {
        const { id, name } = value.ecommerce.click.impressions[0];
        value.ecommerce.click.impressions.forEach((el) => {
          el['dimension35'] = el['dimension35'].split(' ')[0];
          el['variant'] = el['variant'].split(' ')[0];
        });
        dataLayer.push({
          event: 'productClick',
          event_name: 'select_item',
          eventCategory: 'Ecommerce',
          eventAction: 'Product Click',
          eventLabel: [name.toLowerCase().trim()] + '::' + [id],
          product_info: `${[name.toLowerCase().trim()]}::${[id]}`,
          ecommerce: value.ecommerce,
        });
      } else if (
        value.ecommerce &&
        value.ecommerce.click &&
        value.ecommerce.click.products &&
        value.ecommerce.click.products.length
      ) {
        const { id, name } = value.ecommerce.click.products[0];
        value.ecommerce.click.products.forEach((el) => {
          el['dimension35'] = el['dimension35'].split(' ')[0];
          el['variant'] = el['variant'].split(' ')[0];
        });
        dataLayer.push({
          event: 'productClick',
          event_name: 'select_item',
          eventCategory: 'Ecommerce',
          eventAction: 'Product Click',
          eventLabel: [name.toLowerCase().trim()] + '::' + [id],
          product_info: `${[name.toLowerCase().trim()]}::${[id]}`,
          ecommerce: value.ecommerce,
        });
      }
      window.location.href = url;
    },
  },
};
</script>
